<template>
	<div>
		<section class="StoreVideo">
			<div class="bannerVideo">
				<video
					playsinline
					autoplay
					muted
					loop
					poster="/img/video.png"
					id="bgvid"
				>
					<source src="/img/video1.mp4" type="video/mp4" />
				</video>
				<div class="bannerContent">
					<div class="bannerHeading">
						<h2>Exclusive</h2>
						<h3>ABC Galaxy 007</h3>
					</div>
					<div class="bannerButtons">
						<div class="learnMoreButton">Learn More</div>
						<div class="buyNowButton">Buy Now</div>
					</div>
				</div>
				<!-- <video width="100%" height="100%" autoplay poster="/img/video.png">
					<source src="/img/green.mp4" type="video/mp4" />
				</video> -->
			</div>
		</section>
		<div class="browserStore">
			<router-link
				:to="{
					name: 'list',
					query: { store: this.$route.query.store,
              isFromStore: true  },
			  params: {
                      menu_url_key: `store-${$route.query.store}`
                    }
				}"
			>
				Browse Store
			</router-link>
		</div>
		<section v-if="this.$root.window.width < 767">
			<div class="storeHeadingPrimary">
				<h2>Top Selling Picks</h2>
			</div>
			<div class="storeTopSellingTabs">
				<div class="storeTopSellingTab active">Exciting Deals</div>
				<div class="storeTopSellingTab">Mobiles</div>
				<div class="storeTopSellingTab">TV</div>
				<div class="storeTopSellingTab">Watches</div>
				<div class="storeTopSellingTab">Appliances</div>
				<div class="storeTopSellingTab">Accessories</div>
			</div>

			<slick ref="slick3" :options="slickOptions3">
				<div class="slickImages">
					<img class="img-fluid" src="/img/eloctronic1.png" />
				</div>
				<div class="slickImages">
					<img class="img-fluid" src="/img/eloctronic2.png" />
				</div>
				<div class="slickImages">
					<img class="img-fluid" src="/img/eloctronic3.png" />
				</div>
			</slick>
		</section>
		<section v-if="this.$root.window.width > 767">
			<div class="storeHeadingPrimary">
				<h2>Top Selling Picks</h2>
			</div>
			<div class="storeTopSellingTabs">
				<div class="storeTopSellingTab active">Exciting Deals</div>
				<div class="storeTopSellingTab">Mobiles</div>
				<div class="storeTopSellingTab">TV</div>
				<div class="storeTopSellingTab">Watches</div>
				<div class="storeTopSellingTab">Appliances</div>
				<div class="storeTopSellingTab">Accessories</div>
			</div>
			<div class="storeTopSelling">
				<div>
					<img src="/img/eloctronic1.png" />
				</div>
				<div>
					<img src="/img/eloctronic2.png" />
				</div>
				<div>
					<img src="/img/eloctronic3.png" />
				</div>
			</div>
		</section>
		<section class="watchesSection" v-if="this.$root.window.width < 767">
			<div class="watchesSectionHeading">
				<h2>Latest watches you can't resist</h2>
			</div>
			<slick ref="slick3" :options="slickOptions4">
				<div class="watchesCard" v-for="(n, i) in 6" :key="i">
					<div class="watchImage">
						<img src="img/watch.png" />
					</div>
					<div class="watchContent">
						<p class="watchName">Glow black</p>
						<p class="watchPrice">Rs. 24,999</p>
					</div>
				</div>
			</slick>
		</section>
		<section class="watchesSection" v-if="this.$root.window.width > 767">
			<div class="watchesSectionHeading">
				<h2>Latest watches you can't resist</h2>
			</div>
			<div class="watchesGrid">
				<div class="watchesCard" v-for="(n, i) in 6" :key="i">
					<div class="watchImage">
						<img src="img/watch.png" />
					</div>
					<div class="watchContent">
						<p class="watchName">Glow black</p>
						<p class="watchPrice">Rs. 24,999</p>
					</div>
				</div>
			</div>
		</section>
		<section class="tvSection">
			<div class="tvSectionHeading">
				<h2>Led tv</h2>
			</div>
			<slick ref="slick" :options="slickOptions" class="tvSlider">
				<div
					class="tvBanner"
					v-for="(item, index) in 6"
					data-src="img/tv.png"
					:key="index"
				>
					<img
						v-if="$root.window.width < 767"
						src="img/tvMobile.jpg"
						class="w-100"
					/>
					<img v-if="$root.window.width > 767" src="img/tv.png" class="w-100" />
					<div class="tvBannerContent">
						<div class="tvContent">
							<h2>ABC LED Ultra</h2>
							<h3>EMI Starting at 4599<sup>*</sup></h3>
						</div>
						<div class="tvButton">Buy Now</div>
					</div>
				</div>
			</slick>
			<slick ref="slick1" :options="slickOptions1" class="tvTabs">
				<div
					class="tvTab"
					:class="{ active: index == 1 }"
					v-for="(item, index) in 6"
					:key="index"
				>
					test
				</div>
			</slick>
		</section>
		<section class="tvSection mobileSection">
			<div class="tvSectionHeading">
				<h2>Mobile Phones</h2>
			</div>
			<slick ref="slick" :options="slickOptions" class="tvSlider">
				<div
					class="tvBanner"
					v-for="(item, index) in 6"
					data-src="img/tv.png"
					:key="index"
				>
					<img
						v-if="$root.window.width < 767"
						src="img/mobileM.jpg"
						class="w-100"
					/>
					<img
						v-if="$root.window.width > 767"
						src="img/mobile.png"
						class="w-100"
					/>

					<div class="tvBannerContent">
						<div class="tvContent">
							<h2>ABC Phone Ultra</h2>
							<h3>EMI Starting at 4599<sup>*</sup></h3>
						</div>
						<div class="tvButton">Buy Now</div>
					</div>
				</div>
			</slick>
			<slick ref="slick1" :options="slickOptions1" class="tvTabs">
				<div
					class="tvTab"
					:class="{ active: index == 1 }"
					v-for="(item, index) in 6"
					:key="index"
				>
					test
				</div>
				<!-- <img
							v-for="(item, index) in 6"
							:key="index"
							src="img/tv.png"
							
							class="w-100"
						/> -->
			</slick>
		</section>
		<section>
			<div class="policies">
				<div class="storeHeading">
					<h2>policies</h2>
				</div>
				<div class="policyTabs">
					<div
						class="policyTab"
						:class="{ active: id == i }"
						@click="policyContent(i)"
						v-for="(item, i) in policies"
						:key="i"
					>
						{{ item.name }}
					</div>
				</div>
				<p class="policyContent" v-text="content"></p>
			</div>
		</section>
	</div>
	 
</template>
<style>
	video {
		object-fit: cover;
		/* width: 100vw; */
		height: 600px;
		/* position: relative; */
		top: 0;
		left: 0;
	}
	.bannerVideo {
		position: relative;
	}
	.bannerContent {
		position: absolute;
		top: 50%;
		right: 0px;
		transform: translate(-20%, -50%);
	}
	.bannerContent .bannerHeading h2 {
		font-size: 24px;
		line-height: 24px;
		color: #a2a2a2;
		letter-spacing: 1.1em;
		font-family: lhmRegular;
		text-transform: uppercase;
	}
	.bannerContent .bannerHeading h3 {
		font-size: 42px;
		line-height: 24px;
		color: #ee1010;
		font-family: lhmSemiBold;
		margin-top: 20px;
	}
	.bannerButtons {
		margin-top: 60px;
		display: flex;
		justify-content: flex-start;
		color: #000;
		font-size: 16px;
		line-height: 22px;
		font-family: lhmBold;
	}
	.learnMoreButton {
		margin-right: 15px;
		padding: 8px 25px;
		cursor: pointer;
	}
	.buyNowButton {
		border: 1px solid #a2a2a2;
		border-radius: 4px;
		padding: 8px 25px;
		cursor: pointer;
	}
	.storeHeadingPrimary {
		font-size: 36px;
		line-height: 49px;
		color: #626262;
		text-align: center;
		padding: 48px 0px 36px 0px;
	}
	.storeTopSelling {
		margin: 0px !important;
		display: flex;
		justify-content: space-evenly;
	}
	.storeTopSellingTabs {
		margin: 45px 25%;
		display: flex;
		justify-content: space-between;
		font-size:  var(--font-size-heading);
		line-height: 23px;
		font-family: 'lhmRegular';
		color: var(--font-dark-blue);
	}
	.storeTopSellingTab {
		padding: 10px 0px;
		cursor: pointer;
	}
	.storeTopSellingTab.active {
		border-bottom: 1px solid var(--main-color);
	}
	.watchesSection {
		margin-top: 80px;
		padding-bottom: 50px;
		background: linear-gradient(90deg, #ece9e6 0%, #ffffff 100%);
	}
	.watchesCard {
		width: 16%;
		text-align: center;
	}
	.watchesSectionHeading h2 {
		text-transform: uppercase;
		text-align: center;
		font-size: 28px;
		line-height: 84px;
		letter-spacing: 0.3em;
		color: #626262;
		font-family: lhm;
		padding: 42px 0px;
	}
	.watchImage img {
		width: 100%;
		text-align: center;
	}
	p.watchName {
		margin: 0px;
		text-align: center;
		font-size: 24px;
		line-height: 42px;
		font-family: 'lhmRegular';
		color: var(--font-dark-blue);
	}
	p.watchPrice {
		margin: 0px;
		text-align: center;
		font-size: 24px;
		font-family: 'lhmRegular';
		line-height: 42px;
		color: var(--main-color);
	}
	.watchesGrid {
		display: flex;
		/* justify-content: space-around; */
	}
	.tvSectionHeading {
		text-transform: uppercase;
		text-align: center;
		font-size: 28px;
		line-height: 84px;
		letter-spacing: 0.3em;
		color: #626262;
		font-family: lhm;
		padding: 42px 0px;
		position: absolute;
		top: 50px;

		left: 50%;
		z-index: 1;
		transform: translate(-50%, -20%);
	}
	.tvSection {
		position: relative;
	}
	.tvTabs.slick-initialized.slick-slider {
		position: absolute;
		width: 40%;
		left: 50%;
		top: 140px;
		z-index: 2;
		transform: translate(-50%, -50%);
	}
	.tvTab {
		cursor: pointer;
		padding: 10px;
		text-align: center;
	}
	.tvTab.active {
		border-bottom: 1px solid #ee1010;
	}
	.tvBanner {
		position: relative;
	}
	.tvBannerContent {
		position: absolute;
		bottom: -15px;
		left: 50%;
		text-align: center;
		transform: translate(-50%, -50%);
	}
	.tvContent h2 {
		font-size: 42px;
		line-height: 57px;
		color: var(--font-dark-blue);
		font-family: 'lhmSemiBold';
	}
	.tvContent h3 {
		font-size: 24px;
		line-height: 42px;
		color: var(--font-dark-blue);
		font-family: 'lhmRegular';
	}
	.tvButton {
		padding: 8px 25px;
		border: 1px solid var(--font-dark-blue);
		border-radius: 4px;
		display: inline-block;
	}
	/* .mobileSection {
					background: #f5f5f5;
				} */
	.slickImages {
		padding: 5px;
		height: 154px;
		overflow: hidden;
	}

	/* Responsive */
	@media screen and (max-width: 767px) {
		/* .storeTopSelling{
								    flex-direction: column;
					            } */
		video {
			object-fit: cover;
			width: 100vw;
			height: 360px;
			/* position: relative; */
			top: 0;
			left: 0;
		}
		.bannerContent {
			position: absolute;
			top: 20px;
			left: 0px;
			transform: translate(0%, 0%);
		}
		.bannerContent .bannerHeading h2 {
			font-size: 14px;
			line-height: 24px;
			text-align: center;
		}
		.bannerContent .bannerHeading h3 {
			font-size: 24px;
			line-height: 33px;
			text-align: center;
			margin: 0px;
		}
		.bannerButtons {
			margin-top: 15px;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.learnMoreButton {
			order: 2;
			text-decoration: underline;
			margin: 0px;
		}
		.storeHeadingPrimary {
			padding: 10px 0px;
			font-size: 24px;
			line-height: 33px;
        }
        .watchesSection {
            margin-top: 0px;
            padding-bottom: 20px;
        }
		.storeTopSellingTabs {
			overflow-y: hidden;
			overflow-x: scroll;
			margin: 10px;
			white-space: nowrap;
		}
		.storeTopSellingTab {
			margin: 0px 10px;
		}
		.watchesSectionHeading h2 {
			text-transform: uppercase;
			text-align: center;
			font-size:  var(--font-size-heading);
			line-height: 25px;
			letter-spacing: 0.3em;
			color: #626262;
			font-family: lhm;
			padding: 21px 0px;
		}

		.watchesSection button.slick-next.slick-arrow {
			right: 30px;
		}
		.watchesSection button.slick-prev.slick-arrow {
			left: 15px;
		}
		.tvSectionHeading {
			text-transform: uppercase;
			text-align: center;
			font-size: 24px;
			line-height: 33px;
			letter-spacing: 0.3em;
			color: #626262;
			font-family: lhm;
			padding: 0px;
			position: absolute;
			top: 0px;
			white-space: nowrap;
			left: 50%;
			z-index: 1;
			transform: translate(-50%, 0%);
		}
		.tvSection {
			position: relative;
			/* margin: 30px 0px;
			            padding: 60px 0px; */
			box-sizing: border-box;
		}
		.tvTabs.slick-initialized.slick-slider {
			position: absolute;
			width: 100%;
			left: 0;
			top: 40px;
			z-index: 0;
			transform: translate(0%, 0%);
		}
		.tvTab {
			cursor: pointer;
			padding: 10px;
			text-align: center;
		}
		.tvTab.active {
			border-bottom: 1px solid #ee1010;
		}
		.tvBanner {
			position: relative;
		}
		.tvBannerContent {
			position: absolute;
			bottom: 20px;
			left: 0;

			text-align: center;
			width: 100%;
			/* display: flex;
			    justify-content: center;
			    flex-direction: column; */

			left: 50%;
			transform: translate(-50%, 0%);
		}
		.tvContent h2 {
			font-size: 42px;
			line-height: 57px;
			color: var(--font-dark-blue);
			font-family: 'lhmSemiBold';
		}
		.tvContent h3 {
			font-size: 24px;
			line-height: 42px;
			color:var(--font-dark-blue);
			font-family: 'lhmRegular';
		}
		.tvButton {
			padding: 8px 25px;
			border: 1px solid var(--font-dark-blue);
			border-radius: 4px;
			display: block;
			margin: 0px 10px;
		}
		.tvSectionHeading {
			top: 30px;
		}
		.tvTabs.slick-initialized.slick-slider {
			top: 70px;
		}
	}
</style>
<script>
	import axios from "axios";
	import Slick from "vue-slick";
	import lightgallery from "lightgallery.js";
	import "lightgallery.js/dist/css/lightgallery.min.css";
	import "lg-zoom.js";

	export default {
		components: {
			Slick,
		},
		data() {
			return {
				slickOptions: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					fade: false,
					asNavFor: ".tvTabs",
				},
				slickOptions1: {
					slidesToShow: 6,
					slidesToScroll: 1,
					asNavFor: ".tvSlider",
					arrows: false,
					infinite: false,
					centerMode: false,
					focusOnSelect: true,
				},
				slickOptions3: {
					slidesToShow: 4,
					infinite: false,
					dot: true,
					swipeToSlide: true,
					responsive: [
						{
							breakpoint: 767,
							settings: {
								arrows: false,
								slidesToShow: 1.5,
								slidesToScroll: 1,
								// centerMode: true,
								// centerPadding: '0px'
							},
						},
					],
					// Any other options that can be got from plugin documentation
				},
				slickOptions4: {
					slidesToShow: 4,
					infinite: false,
					dot: true,
					swipeToSlide: true,
					responsive: [
						{
							breakpoint: 767,
							settings: {
								arrows: true,
								slidesToShow: 1,
								slidesToScroll: 1,
								arrows: true,
								// centerMode: true,
								// centerPadding: '0px'
							},
						},
					],
					// Any other options that can be got from plugin documentation
				},
				policies: [
					{
						name: "About",
						content:
							"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non velit suscipit fugiat ipsa deleniti delectus mollitia blanditiis, neque debitis nihil et error, natus necessitatibus architecto labore quis magnam molestias dolore. Asperiores sunt, eius nemo tempore debitis perspiciatis ad consequuntur rerum in explicabo exercitationem ipsa esse! Eveniet blanditiis debitis possimus dolores.",
					},
					{
						name: "Return",
						content:
							"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non velit suscipit fugiat ipsa deleniti delectus mollitia blanditiis, neque debitis nihil et error, natus necessitatibus architecto labore quis magnam molestias dolore. Asperiores sunt, eius nemo tempore debitis perspiciatis ad consequuntur rerum in explicabo exercitationem ipsa esse! Eveniet blanditiis debitis possimus dolores.",
					},
					{
						name: "Shipping",
						content:
							"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non velit suscipit fugiat ipsa deleniti delectus mollitia blanditiis, neque debitis nihil et error, natus necessitatibus architecto labore quis magnam molestias dolore. Asperiores sunt, eius nemo tempore debitis perspiciatis ad consequuntur rerum in explicabo exercitationem ipsa esse! Eveniet blanditiis debitis possimus dolores.Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non velit suscipit fugiat ipsa deleniti delectus mollitia blanditiis, neque debitis nihil et error, natus necessitatibus architecto labore quis magnam molestias dolore. Asperiores sunt, eius nemo tempore debitis perspiciatis ad consequuntur rerum in explicabo exercitationem ipsa esse! Eveniet blanditiis debitis possimus dolores.",
					},
					{
						name: "Policies",
						content:
							"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Non velit suscipit fugiat ipsa deleniti delectus mollitia blanditiis, neque debitis nihil et error, natus necessitatibus architecto labore quis magnam molestias dolore. Asperiores sunt, eius nemo tempore debitis perspiciatis ad consequuntur rerum in explicabo exercitationem ipsa esse! Eveniet blanditiis debitis possimus dolores.",
					},
				],
				id: 1,
			};
		},
		methods: {
			policyContent(id) {
				this.id = id;
				this.content = this.policies[id].content;
				// console.log(this.policies[id].content);
			},
		},
	};
</script>